module.exports = __webpack_public_path__ + "media/bedrooms.e1071411.svg";